import DateParserModule from './date-parser';
import template from './datepicker.jade';

export class DatepickerController {
  /* @ngInject */
  constructor() {
    this.today = new Date()
    if(this.date == null) {
      this.current = this.today;
    } else {
      this.current = new Date(this.date);
    }

    this.buildWeeks();
    this.months = [
      {id: '0', name: 'Jan'},
      {id: '1', name: 'Feb'},
      {id: '2', name: 'Mar'},
      {id: '3', name: 'Apr'},
      {id: '4', name: 'May'},
      {id: '5', name: 'Jun'},
      {id: '6', name: 'Jul'},
      {id: '7', name: 'Aug'},
      {id: '8', name: 'Sep'},
      {id: '9', name: 'Oct'},
      {id: '10', name: 'Nov'},
      {id: '11', name: 'Dec'}
    ];
  }

  get showError() {
    return this.options && this.options.formControl && !_.isEmpty(this.options.formControl.$error);
  }

  get currentMonth() {
    return String(this.current.getMonth());
  }

  set currentMonth(month) {
    this.current = moment(this.current).month(parseInt(month)).toDate();
    this.buildWeeks();
  }

  get years() {
    return _.range(-1, 2).map(n => {
      return moment(this.current).add(n, 'years').toDate().getFullYear();
    });
  }

  get currentYear() {
    return this.current.getFullYear();
  }

  set currentYear(year) {
    this.current = moment(this.current).year(year).toDate();
    this.buildWeeks();
  }

  buildWeeks() {
    let day = moment(this.current).startOf('month').startOf('isoweek');
    let endDate = moment(this.current).endOf('month').endOf('isoweek');
    let weeks = [];

    while (day <= endDate) {
      let endOfWeek = day.clone().endOf('isoweek');
      let days = [];
      while (day <= endOfWeek) {
        days.push(day.toDate());
        day = day.clone().add(1, 'd');
      }
      weeks.push(days);
    }
    this.weeks = weeks;
  }

  next() {
    this.current = moment(this.current).add(1, 'month').toDate();
    this.buildWeeks();
  }

  prev() {
    this.current = moment(this.current).subtract(1, 'month').toDate();
    this.buildWeeks();
  }

  dayClasses(date) {
    let isSelected = false;
    if (this.date) {
      isSelected = moment(date).isSame(this.date, 'day');
    }
    let isToday = moment(date).isSame(this.today, 'day');
    let isDifferentMonth = this.current && (date.getFullYear() != this.current.getFullYear() || date.getMonth() != this.current.getMonth());

    return _.pickBy({
      'is-active': isSelected,
      'is-different-month': isDifferentMonth,
      'c-calendar__day--start-range': isSelected,
      'c-calendar__day--end-range': isSelected,
      'c-calendar__day--today': isToday
    }, value => value);
  }

  close() {
    // defined in link
  }

  select(date) {
    this.close();
    this.date = date;
  }

  onChange() {
    if (_.isDate(this.date)) {
      this.current = this.date;
      this.buildWeeks();
    }
  }
}

export function DatepickerComponent() {
  return {
    template,
    controller: DatepickerController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      date: '=ngModel',
      required: '=ngRequired',
      setDefaultInitialValue: '=setDefaultInitialValue',
      options: '='
    },
    bindToController: true,
    link: function (scope, element, attrs) {
      let openClass = 'is-open';

      scope.vm.close = (() => {
        element.find('.c-picker').removeClass(openClass);
      });

      element.find('.c-picker__input').click(function (event) {
        element.find('.c-picker').addClass(openClass);
      });

      // we need to use mousedown due to angular bug (ignores first click when input has focus)
      element.parents('body').bind('mousedown', (event) => {
        if (!element[0].contains(event.target)) {
          scope.$apply(() => {
            element.find('.c-picker').removeClass(openClass);
          });
        }
      });
    }
  };
};

export default angular.module('app.datetime.datepicker', [
  DateParserModule.name
])
.directive('datepicker', DatepickerComponent);



/** WEBPACK FOOTER **
 ** ./src/common/datetime/datepicker.js
 **/